<script setup>
import {inject} from 'vue'

const { file_filter, setFilter } = inject('filter');

const toggleFilter = (type, value) => {
  if(file_filter.value.hasOwnProperty(type)){
    let filter = Object.assign({}, file_filter.value);
    if(type === 'language'){
      if(isFilterActive(type, value)){
        filter[type].value = []
      }else{
        filter[type].value = [value]
      }
    }else{
      if(isFilterActive(type, value)){
        filter[type].value.splice(filter[type].value.indexOf(value), 1);
      }else{
        filter[type].value.push(value);
      }
    }
    filter[type].active = filter[type].value.length > 0;
    setFilter(filter);
  }else{
    console.error('filter type is not defined', type);
  }
};

const isFilterActive = (type, value) => {
  if(file_filter.value.hasOwnProperty(type)) {
    let filter = Object.assign({}, file_filter.value);
    return filter[type].value.includes(value);
  }
  return false;
}
</script>

<template>
  <div class="filter-container container-fluid position-fixed z-3" :class="{isMobile:$isMobile()}">
    <div class="row justify-content-center">
      <div class="filter-body col col-auto rounded border border-4">
        <div class="row row-cols-9 py-1 ps-0 pe-2">
          <div class="col p-0 px-1">
            <div class="filter-language border border-1 rounded px-1" :class="{active:isFilterActive('language',filter)}" v-for="(title, filter) in file_filter.language.options">
              <a href="#" @click.prevent="toggleFilter('language',filter)">{{title}}</a>
            </div>
          </div>
          <div v-for="filter in file_filter.types.options" class="col p-0">
            <a href="#" class="button-filter" :class="{active:isFilterActive('types',filter.filetype_id)}" @click.prevent="toggleFilter('types',filter.filetype_id)"><i class="icon" :class="filter.icon"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../scss/styles';

.filter-container {
  bottom:6.5rem !important;
  .filter-body {
    background-color: $shark;
    border-color: $blue !important;
    .row{
      padding-left:0 !important;
      .col{
        overflow: hidden;
        max-width: fit-content;
        .button-filter{
          opacity: 0.3;
          .icon{
            max-height: 50px;
            max-width: 100%;
          }
          &:hover{
            opacity: 0.6;
          }
          &.active{
            opacity: 1;
            .icon{
              border-bottom: 1px solid $blue !important;
            }
          }
        }
        .filter-language{
          background-color: $koala;
          border-color: white !important;
          border-radius: 0.2rem !important;
          margin-right: 0.3rem !important;
          a{
            color: $white !important;
            text-decoration: none !important;
          }
          &.active, &:hover{
            background-color: $blue;
          }
        }
      }
    }
  }
  &.isMobile{
    .button-filter{
      &:hover{
        opacity: 0.3 !important;
      }
      &.active{
        opacity: 1 !important;
      }
    }
    .filter-language {
      &:hover {
        background-color: $koala !important;
      }
      &.active {
        background-color: $blue !important;
      }
    }
  }
}

</style>